import React, { useEffect, useCallback } from 'react';

import styles from './Toolbar.scss';
import { connect } from 'react-redux';
import { __ } from '../../../../core/utils';
import { withRouter } from 'react-router';

import Hand from '../Hand/Hand';
import Select from '../Select';
import Line from '../Line';
import Arrow from '../Arrow';
import Ellipse from '../Ellipse';
import Rect from '../Rect';
import Textbox from '../Textbox';
import Delete from '../Delete';
import Color from '../Color/Color';
import Pencil from '../Draw/Pencil';
import Highlighter from '../Draw/Highlighter';
import Thickness from '../Thickness/Thickness';

import { updateTool } from '../../../../redux/actions/canvas_editor';

const EMPTY_SOURCE = {};

const PdfToolbar = ({
  canvas_editor: { activeTool },
  source,
  sourceType,
}) => {
  const toolbarSource = source || EMPTY_SOURCE;

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      updateTool({ tool: 'hand' });
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  const drawingTools = (
    <>
      <Line
        isActive={activeTool === 'line'}
        source={toolbarSource}
        sourceType={sourceType}
      />
      <Arrow
        isActive={activeTool === 'arrow'}
        source={toolbarSource}
        sourceType={sourceType}
      />
      <Rect
        isActive={activeTool === 'rect'}
        source={toolbarSource}
        sourceType={sourceType}
      />
      <Ellipse
        isActive={activeTool === 'ellipse'}
        source={toolbarSource}
        sourceType={sourceType}
      />
      <Textbox
        isActive={activeTool === 'textbox'}
        source={toolbarSource}
        sourceType={sourceType}
      />
      <Pencil
        isActive={activeTool === 'pencil'}
        source={toolbarSource}
        sourceType={sourceType}
      />
      <Highlighter
        isActive={activeTool === 'highlighter'}
        source={toolbarSource}
        sourceType={sourceType}
      />

      <Color />
      <Thickness />
    </>
  );

  return (
    <div className={styles.PDFToolbar}>
      <Hand source={toolbarSource} sourceType={sourceType} />

      <Select source={toolbarSource} />

      {drawingTools}

      <Delete />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
  };
};

export default withRouter(connect(mapStateToProps, null)(PdfToolbar));
